import React from 'react';
import { TrainingState, useTrainingStore } from '~/training/state';
import { SettingsPages, useSettingsStore } from '../Store';
import { LocalePage } from './LocalePage';

const selector = (s: TrainingState) => {
  const defaultLng = ['en'];

  if (s.subtitleLocales.includes('es')) {
    defaultLng.push('es');
  }

  return {
    locale: s.subtitleLocale,
    availableLocales: [
      ...defaultLng,
      ...s.subtitleLocales.filter(i => i != 'en' && i != 'es')
    ],
    setLocale: s.setSubtitleLocale
  };
};

export const SubtitleLocalePage = () => {
  const props = useTrainingStore(selector);
  const { page } = useSettingsStore();
  if (page !== SettingsPages.SubtitleLocale) return null;

  return <LocalePage {...props} />;
};
